export default __webpack_public_path__ + "static/media/crystal.e9c00549.png";